import { render, staticRenderFns } from "./weeklyplan.vue?vue&type=template&id=249cea9e&"
import script from "./weeklyplan.vue?vue&type=script&lang=js&"
export * from "./weeklyplan.vue?vue&type=script&lang=js&"
import style0 from "./weeklyplan.vue?vue&type=style&index=0&id=249cea9e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports